import type { Product } from '@/lib/api.types'

import TicketsListView from '../ListView'

interface ProductsListProps {
  categoryId: number | string | null
  categoryName: string
  coverImageUrl?: string
  products: Product[]
  accessibilityMode?: boolean
  currency?: string
  simpleHero?: boolean
}

const ProductsList = (props: ProductsListProps) => <TicketsListView {...props} cardType="product" />

export default ProductsList
